import { Injectable, inject } from '@angular/core';
import { catchError, map, of, Observable } from 'rxjs';
import {
  MODEL,
  PROVISIONING_STATUS,
  RAN_CONFIGURATION,
  VPN_CONFIGURATION
} from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.constants';
import {
  FilterModel,
  FilterModels,
  ListingFiltersSource
} from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.types';
import { BaseStationService } from './base-stations-listing.service';

@Injectable()
export class BaseStationListingFiltersSourceService implements ListingFiltersSource {
  private readonly baseStationService = inject(BaseStationService);

  getAll(): Observable<FilterModels> {
    return this.baseStationService.getModelsFilter().pipe(
      map(modelFilter => [modelFilter, PROVISIONING_STATUS, RAN_CONFIGURATION, VPN_CONFIGURATION]),
      catchError(() => of([MODEL, PROVISIONING_STATUS, RAN_CONFIGURATION, VPN_CONFIGURATION]))
    );
  }

  getReportGroup(): Observable<FilterModel> {
    return of();
  }
}
